import * as React from 'react';
import * as Classes from '../common/classes';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../form/Field';
import { VFFilterFieldProps } from '../form/types';
import { FilterItem } from './FilterItem';
import { FilterFieldProps, getFilterFieldFormValuePath } from './types';
import {
  defaultMultiSelectGetLabel,
  MultiSelectSearch,
} from '../multiselect/MultiSelectSearch';
import classNames from 'classnames';
import { Text } from '../typography/Text';
import { isMobile } from '../common/utils';
import { FilterInputButton } from '../button/FilterInputButton';
import { DATA_FILTER_INPUT } from '../common/data';

export type FilterMultiSelectProps = VFFilterFieldProps<
  Omit<React.ComponentProps<typeof MultiSelectSearch>, 'hideCloseButton'> &
    FilterFieldProps
>;
export const FilterMultiSelect = React.forwardRef<
  HTMLInputElement,
  FilterMultiSelectProps
>(
  (
    {
      name,
      getLabel = defaultMultiSelectGetLabel,
      validate,
      className,
      inputClassName,
      label,
      required,
      disabled,
      filterType,
      size = 14,
      items,
      title,
      extendedFilter,
      ...other
    },
    ref
  ) => {
    return (
      <FilterItem
        name={name}
        className={className}
        label={label}
        disabled={disabled}
        filterType={filterType}
        extendedFilter={extendedFilter}
      >
        <Field
          name={getFilterFieldFormValuePath(name, filterType)}
          validate={validate}
        >
          {({
            input: { value, onChange, onBlur, name, ...nother },
            meta,
          }: FieldRenderProps<any[]>) => {
            let titleArr: string[] = [];
            // let tooltipArr: any[] = [];
            items.forEach((i) => {
              if (value.indexOf(i.id) >= 0) {
                titleArr.push(getLabel(i));
                // tooltipArr.push(<ListItem>{getLabel(i)}</ListItem>);
              }
            });

            let info: React.ReactNode = '-';
            if (!value || value.length === 0) {
              info = (
                <Text intent={'inactive'} italic>
                  Nevybráno
                </Text>
              );
            } else if (value.length === 1) {
              info = titleArr[0];
            } else {
              info = `${titleArr[0]} +${value.length - 1}`;
            }

            return (
              <FilterInputButton
                {...DATA_FILTER_INPUT(name)}
                tooltip={
                  titleArr.length > 0 ? titleArr.join(', ') : 'Nevybráno'
                  // tooltipArr.length > 0 ? (
                  //   <List
                  //     compact
                  //     noTopBottomRows
                  //     style={{ maxHeight: 300, overflowY: 'auto' }}
                  //   >
                  //     {tooltipArr}
                  //   </List>
                  // ) : (
                  //   '-nevybráno-'
                  // )
                }
                className={Classes.FILTER_MULTI_SELECT}
                disabled={disabled || meta.submitting}
                cssStyle={{
                  width: `${size}em`,
                }}
                popupProps={{
                  mode: 'edit',
                  closeOnInnerClick: false,
                  arrow: true,
                  focusContentOnOpen: true,
                  position: isMobile
                    ? ['bottom left', 'top left', 'bottom center', 'top center']
                    : undefined,
                }}
                menu={(closePopup) => (
                  <MultiSelectSearch
                    closePopup={closePopup}
                    className={classNames(
                      inputClassName,
                      Classes.FILTER_MULTI_LIST
                    )}
                    value={value}
                    // @ts-ignore
                    ref={ref}
                    {...nother}
                    {...other}
                    onChange={(ids) => {
                      onChange({ target: { name, value: ids } });
                    }}
                    title={label}
                    items={items}
                  />
                )}
              >
                {info}
              </FilterInputButton>
            );
          }}
        </Field>
      </FilterItem>
    );
  }
);
